import { render, staticRenderFns } from "./shortvideo.vue?vue&type=template&id=dcc3a2a4&scoped=true"
import script from "./shortvideo.vue?vue&type=script&lang=js"
export * from "./shortvideo.vue?vue&type=script&lang=js"
import style0 from "./shortvideo.vue?vue&type=style&index=0&id=dcc3a2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc3a2a4",
  null
  
)

export default component.exports